import * as Layout from './components/pages/Layout/Layout.css';
import * as CategoriesListPage from './components/pages/CategoriesListPage/CategoriesListPage.css';
import * as CategoryCard from './components/pages/CategoriesListPage/CategoryCard/CategoryCard.css';
import * as NotificationCard from './components/shared/NotificationCard/NotificationCard.css';
import * as Breadcrumbs from './components/shared/Breadcrumbs/Breadcrumbs.css';
import * as EmptyBanner from './components/shared/EmptyBanner/EmptyBanner.css';
import * as Header from './components/shared/Header/Header.css';
import * as DateSeparator from './components/shared/DateSeparator/DateSeparator.css';
import * as CategoryListWrapper from './components/shared/CategoryListWrapper/CategoryListWrapper.css';
import * as DetailWrapper from './components/shared/DetailWrapper/DetailWrapper.css';
import * as GroupedList from './components/shared/GroupedList/GroupedList.css';
import Skeleton from './components/shared/Skeleton/theme';

import * as AppealCard from './components/categories/Appeals/AppealCard/AppealCard.css';
import * as OrderCard from './components/categories/Orders/OrderCard/OrderCard.css';
import PromoCode from './components/categories/PromoCodes/theme';

export default {
	Layout,
	CategoriesListPage,
	CategoryCard,
	Header,
	NotificationCard,
	Breadcrumbs,
	EmptyBanner,
	AppealCard,
	OrderCard,
	PromoCode,
	GroupedList,
	Skeleton,
	CategoryListWrapper,
	DetailWrapper,
	DateSeparator
};
